module.exports = __webpack_public_path__ + "static/media/stockhausen_augen_13.b180d1ce.jpg";